import type { SVGProps, ReactNode } from 'react';

interface SVGRProps {
  title?: string;
  titleId?: string;
}

export function SvgLaptop({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): ReactNode {
  return (
    <svg
      aria-labelledby={titleId}
      fill="none"
      height={200}
      viewBox="0 0 200 200"
      width={200}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="m113.861 26.67-1.005-.62c-.155-.076-.464-.076-.773.078l-74 42.683c-.619.31-1.083 1.16-1.083 1.856v70.057c0 .309.155.618.31.696l.927.541c.232.077.464.077.774-.078l74.077-42.606c.618-.309 1.082-1.16 1.082-1.855V27.365c0-.386-.077-.541-.309-.696"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.5}
      />
      <path
        d="m39.088 69.43 74-42.683c.618-.31 1.082-.078 1.082.618v70.057c0 .696-.464 1.546-1.082 1.855l-74 42.684c-.619.309-1.083.077-1.083-.619V71.286c.078-.696.542-1.547 1.083-1.856Z"
        fill="#EFE9FE"
        stroke="#1D1D1B"
        strokeWidth={0.5}
      />
      <path
        d="m41.64 72.987 68.896-39.745v58.767L41.64 131.754z"
        fill="#fff"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.5}
      />
      <path
        d="m169.689 127.296-55.21-31.858c-.541-.31-1.314-.31-1.855 0l-74.387 42.915c-.232.155-.387.31-.387.542v2.474c0 .232.155.387.387.541l55.21 31.858c.541.31 1.314.31 1.856 0l74.386-42.915c.232-.155.387-.309.387-.541v-2.475c0-.154-.077-.386-.387-.541"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.5}
      />
      <path
        d="m114.557 95.438 55.132 31.858c.542.309.542.773 0 1.083l-74.386 42.915c-.541.309-1.315.309-1.856 0l-55.21-31.858c-.541-.309-.541-.773 0-1.083l74.387-42.915c.541-.31 1.391-.31 1.933 0"
        fill="#fff"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.5}
      />
      <rect
        fill="#EFE9FE"
        height={54.289}
        rx={3.043}
        stroke="#1D1D1B"
        strokeWidth={0.5}
        transform="matrix(-.86601 .50003 -.00003 1 129.089 31.108)"
        width={79.742}
        x={-0.217}
        y={0.375}
      />
      <path
        d="m60.217 76.044 69.058-39.871v-1.755c0-1.68-1.18-2.362-2.635-1.521L62.852 69.725c-1.455.84-2.635 2.884-2.635 4.564z"
        fill="#D5C8FB"
        stroke="#1D1D1B"
        strokeWidth={0.5}
      />
      <circle fill="#D5C8FB" r={14.25} transform="matrix(.86601 -.50003 -.00003 1 99.01 79.786)" />
      <mask
        height={34}
        id="laptop_svg__a"
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
        width={26}
        x={86}
        y={63}
      >
        <circle
          fill="#D9D9D9"
          r={14.25}
          stroke="#1D1D1B"
          strokeWidth={0.5}
          transform="matrix(.86601 -.50003 -.00003 1 99.011 79.787)"
        />
      </mask>
      <g fill="#fff" mask="url(#laptop_svg__a)" stroke="#1D1D1B" strokeWidth={0.5}>
        <path d="M109.706 89.276c0-3.082-1.06-5.425-2.947-6.515s-4.447-.836-7.115.705-5.228 4.243-7.115 7.512-2.948 6.836-2.948 9.917l10.062-5.81z" />
        <circle r={5.679} transform="matrix(.86601 -.50003 -.00003 1 99.644 76.388)" />
      </g>
      <circle
        r={14.25}
        stroke="#1D1D1B"
        strokeWidth={0.5}
        transform="matrix(.86601 -.50003 -.00003 1 99.01 79.787)"
      />
      <path
        d="M70.697 101.794V92l5.227 2.02z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinejoin="round"
        strokeWidth={0.387}
      />
      <mask
        height={37}
        id="laptop_svg__b"
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
        width={48}
        x={29}
        y={88}
      >
        <path
          d="m34 124-4.5-7.5 43.5-28 3.5 14.5z"
          fill="#D9D9D9"
          stroke="#000"
          strokeWidth={0.5}
        />
      </mask>
      <g mask="url(#laptop_svg__b)">
        <path d="m29 120.782 41.57-24" stroke="#1D1D1B" strokeDasharray="3 3" strokeWidth={0.975} />
      </g>
      <rect
        fill="#fff"
        height={11.446}
        rx={0.3}
        stroke="#1D1D1B"
        strokeWidth={0.5}
        transform="matrix(.86603 -.5 .86603 .5 107 145.638)"
        width={23.279}
      />
      <rect
        fill="#EFE9FE"
        height={6.869}
        rx={0.3}
        stroke="#1D1D1B"
        strokeWidth={0.5}
        transform="matrix(.86603 -.5 .86603 .5 62.044 146.14)"
        width={7.383}
      />
      <rect
        fill="#EFE9FE"
        height={6.869}
        rx={0.3}
        stroke="#1D1D1B"
        strokeWidth={0.5}
        transform="matrix(.86603 -.5 .86603 .5 67.993 149.575)"
        width={7.383}
      />
      <rect
        fill="#EFE9FE"
        height={6.869}
        rx={0.3}
        stroke="#1D1D1B"
        strokeWidth={0.5}
        transform="matrix(.86603 -.5 .86603 .5 87.624 131.376)"
        width={7.383}
      />
      <rect
        fill="#EFE9FE"
        height={6.869}
        rx={0.3}
        stroke="#1D1D1B"
        strokeWidth={0.5}
        transform="matrix(.86603 -.5 .86603 .5 68.44 142.449)"
        width={7.383}
      />
      <rect
        fill="#EFE9FE"
        height={6.869}
        rx={0.3}
        stroke="#1D1D1B"
        strokeWidth={0.5}
        transform="matrix(.86603 -.5 .86603 .5 74.388 145.883)"
        width={7.383}
      />
      <rect
        fill="#EFE9FE"
        height={6.869}
        rx={0.3}
        stroke="#1D1D1B"
        strokeWidth={0.5}
        transform="matrix(.86603 -.5 .86603 .5 94.017 127.683)"
        width={7.383}
      />
      <rect
        fill="#EFE9FE"
        height={6.869}
        rx={0.3}
        stroke="#1D1D1B"
        strokeWidth={0.5}
        transform="matrix(.86603 -.5 .86603 .5 74.834 138.757)"
        width={7.383}
      />
      <rect
        fill="#EFE9FE"
        height={6.869}
        rx={0.3}
        stroke="#1D1D1B"
        strokeWidth={0.5}
        transform="matrix(.86603 -.5 .86603 .5 80.782 142.192)"
        width={7.383}
      />
      <rect
        fill="#EFE9FE"
        height={6.869}
        rx={0.3}
        stroke="#1D1D1B"
        strokeWidth={0.5}
        transform="matrix(.86603 -.5 .86603 .5 100.412 123.989)"
        width={7.383}
      />
      <rect
        fill="#EFE9FE"
        height={6.869}
        rx={0.3}
        stroke="#1D1D1B"
        strokeWidth={0.5}
        transform="matrix(.86603 -.5 .86603 .5 113.201 116.606)"
        width={7.383}
      />
      <rect
        fill="#EFE9FE"
        height={6.869}
        rx={0.3}
        stroke="#1D1D1B"
        strokeWidth={0.5}
        transform="matrix(.86603 -.5 .86603 .5 119.148 120.04)"
        width={7.383}
      />
      <rect
        fill="#EFE9FE"
        height={6.869}
        rx={0.3}
        stroke="#1D1D1B"
        strokeWidth={0.5}
        transform="matrix(.86603 -.5 .86603 .5 81.229 135.064)"
        width={7.383}
      />
      <rect
        fill="#EFE9FE"
        height={6.869}
        rx={0.3}
        stroke="#1D1D1B"
        strokeWidth={0.5}
        transform="matrix(.86603 -.5 .86603 .5 106.807 120.298)"
        width={7.383}
      />
      <rect
        fill="#EFE9FE"
        height={6.813}
        rx={0.3}
        stroke="#1D1D1B"
        strokeWidth={0.5}
        transform="matrix(.86603 -.5 .86603 .5 112.805 123.764)"
        width={7.383}
      />
      <rect
        fill="#EFE9FE"
        height={6.869}
        rx={0.3}
        stroke="#1D1D1B"
        strokeWidth={0.5}
        transform="matrix(.86603 -.5 .86603 .5 119.595 112.914)"
        width={7.383}
      />
      <rect
        fill="#EFE9FE"
        height={6.859}
        rx={0.3}
        stroke="#1D1D1B"
        strokeWidth={0.5}
        transform="matrix(.86603 -.5 .86603 .5 125.552 116.353)"
        width={7.383}
      />
      <rect
        fill="#EFE9FE"
        height={6.869}
        rx={0.3}
        stroke="#1D1D1B"
        strokeWidth={0.5}
        transform="matrix(.86603 -.5 .86603 .5 87.178 138.5)"
        width={29.534}
      />
      <rect
        fill="#EFE9FE"
        height={6.869}
        rx={0.3}
        stroke="#1D1D1B"
        strokeWidth={0.5}
        transform="matrix(.86603 -.5 .86603 .5 56.096 142.704)"
        width={7.383}
      />
      <rect
        fill="#EFE9FE"
        height={6.869}
        rx={0.3}
        stroke="#1D1D1B"
        strokeWidth={0.5}
        transform="matrix(.86603 -.5 .86603 .5 81.673 127.943)"
        width={7.383}
      />
      <rect
        fill="#EFE9FE"
        height={6.869}
        rx={0.3}
        stroke="#1D1D1B"
        strokeWidth={0.5}
        transform="matrix(.86603 -.5 .86603 .5 62.49 139.011)"
        width={7.383}
      />
      <rect
        fill="#EFE9FE"
        height={6.869}
        rx={0.3}
        stroke="#1D1D1B"
        strokeWidth={0.5}
        transform="matrix(.86603 -.5 .86603 .5 88.067 124.245)"
        width={7.383}
      />
      <rect
        fill="#EFE9FE"
        height={6.869}
        rx={0.3}
        stroke="#1D1D1B"
        strokeWidth={0.5}
        transform="matrix(.86603 -.5 .86603 .5 68.884 135.32)"
        width={7.383}
      />
      <rect
        fill="#EFE9FE"
        height={6.869}
        rx={0.3}
        stroke="#1D1D1B"
        strokeWidth={0.5}
        transform="matrix(.86603 -.5 .86603 .5 94.462 120.552)"
        width={7.383}
      />
      <rect
        fill="#EFE9FE"
        height={6.869}
        rx={0.3}
        stroke="#1D1D1B"
        strokeWidth={0.5}
        transform="matrix(.86603 -.5 .86603 .5 75.279 131.63)"
        width={7.383}
      />
      <rect
        fill="#EFE9FE"
        height={6.869}
        rx={0.3}
        stroke="#1D1D1B"
        strokeWidth={0.5}
        transform="matrix(.86603 -.5 .86603 .5 100.858 116.864)"
        width={7.383}
      />
      <rect
        fill="#EFE9FE"
        height={6.869}
        rx={0.3}
        stroke="#1D1D1B"
        strokeWidth={0.5}
        transform="matrix(.86603 -.5 .86603 .5 107.25 113.169)"
        width={14.767}
      />
    </svg>
  );
}
